
<template>
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.51669 2.36713L3.02502 5.86713C2.27502 6.45046 1.66669 7.69213 1.66669 8.63379V14.8088C1.66669 16.7421 3.24169 18.3255 5.17502 18.3255H14.825C16.7584 18.3255 18.3334 16.7421 18.3334 14.8171V8.75046C18.3334 7.74213 17.6584 6.45046 16.8334 5.87546L11.6834 2.26713C10.5167 1.45046 8.64169 1.49213 7.51669 2.36713Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10 14.9912V12.4912" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

</template>
     
<script>
export default {
  name: 'DashboardIcon',

  data() {
    return {
      
    }
  },
  computed: {
  },
};
</script>
